import React from "react";
import { SideMenu } from "./../../components";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import "./purchases-product.css";
import { Button } from "@mui/material";
import PenImg from "./../../../assets/images/pen.jpg";
import { useNavigate } from "react-router-dom";
const PurchasesProduct = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = React.useState(0);
  const Tags = [
    { title: "All" },
    { title: "Pen" },
    { title: "Pencils" },
    { title: "Notepade" },
    { title: "Notebooks" },
    { title: "Marker & Highligters" },
    { title: "business" },
  ];
  const [cardData, setCardData] = React.useState([
    {
      des: "Classmate Octane Colour Burst - Count of 10 (assorted)",
      price: 8,
      add: false,
      counter: 1,
    },
    {
      des: "Classmate Octane Colour Burst - Count of 10 (assorted)",
      price: 8,
      add: false,
      counter: 1,
    },

    {
      des: "Classmate Octane Colour Burst - Count of 10 (assorted)",
      price: 8,
      add: false,
      counter: 1,
    },

    {
      des: "Classmate Octane Colour Burst - Count of 10 (assorted)",
      price: 8,
      add: false,
      counter: 1,
    },
    {
      des: "Classmate Octane Colour Burst - Count of 10 (assorted)",
      price: 8,
      add: false,
      counter: 1,
    },
    {
      des: "Classmate Octane Colour Burst - Count of 10 (assorted)",
      price: 8,
      add: false,
      counter: 1,
    },
    {
      des: "Classmate Octane Colour Burst - Count of 10 (assorted)",
      price: 8,
      add: false,
      counter: 1,
    },
    {
      des: "Classmate Octane Colour Burst - Count of 10 (assorted)",
      price: 8,
      add: false,
      counter: 1,
    },
    {
      des: "Classmate Octane Colour Burst - Count of 10 (assorted)",
      price: 8,
      add: false,
      counter: 1,
    },
    {
      des: "Classmate Octane Colour Burst - Count of 10 (assorted)",
      price: 8,
      add: false,
      counter: 1,
    },
    {
      des: "Classmate Octane Colour Burst - Count of 10 (assorted)",
      price: 8,
      add: false,
      counter: 1,
    },
    {
      des: "Classmate Octane Colour Burst - Count of 10 (assorted)",
      price: 8,
      add: false,
      counter: 1,
    },
    {
      des: "Classmate Octane Colour Burst - Count of 10 (assorted)",
      price: 8,
      add: false,
      counter: 1,
    },
    {
      des: "Classmate Octane Colour Burst - Count of 10 (assorted)",
      price: 8,
      add: false,
      counter: 1,
    },
  ]);

  const DecrementHandler = (cardIndex) => {
    if (cardData[cardIndex].counter > 1) {
      cardData[cardIndex].counter = cardData[cardIndex].counter - 1;
      setCardData([...cardData]);
    }
  };
  return (
    <SideMenu purchseIcon={true}>
      <div className="purchase-product-container">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
              <div>
                <p className="header-input-heading">Search by cource name</p>
                <input
                  type="text"
                  className="header-input"
                  placeholder="Search by cource name"
                />
              </div>
            </Grid>
            <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
              <div>
                <p className="header-input-heading">Search by cource name</p>
                <input
                  type="number"
                  className="header-input"
                  placeholder="Search by price"
                />
              </div>
            </Grid>
            <Grid item xl={2} lg={2} md={12} sm={12} xs={12}>
              <Button className="header-apply-button" variant="text">
                <p className="header-apply-button-text">Apply</p>
              </Button>
            </Grid>
          </Grid>
        </Box>

        <div className="purchase-product-tags-main">
          {Tags.map((tagsValue, tagsIndex) => {
            return (
              <Button
                className={
                  activeTab === tagsIndex
                    ? "purchase-product-selected-tag"
                    : "purchase-product-un-selected-tags"
                }
                variant="text"
                key={tagsIndex}
                onClick={() => setActiveTab(tagsIndex)}
              >
                {tagsValue.title}
              </Button>
            );
          })}
        </div>
        <br />
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            {cardData.map((cardValue, cardIndex) => {
              return (
                <Grid item xl={4} lg={4} md={6} sm={12} xs={12} key={cardIndex}>
                  <div className="purchase-product-card-container">
                    <Button
                      style={{ width: "100%" }}
                      onClick={() => navigate("/purchases-product/view")}
                    >
                      <img
                        src={PenImg}
                        className="purchase-product-card-image"
                      />
                    </Button>
                    <p className="purchase-product-card-desctiption">
                      {cardValue.des}
                    </p>
                    <div className="purchase-product-card-price-main">
                      <p className="purchase-product-card-price">
                        ${cardValue.price * cardValue.counter}
                      </p>
                      {!cardValue.add ? (
                        <Button
                          className="purchase-product-card-add-button"
                          variant="text"
                          onClick={() => {
                            cardData[cardIndex].add = true;
                            setCardData([...cardData]);
                          }}
                        >
                          <p className="header-apply-button-text">ADD</p>
                        </Button>
                      ) : (
                        <div className="purchase-product-card-inc-dec-main">
                          <button
                            className="purchase-product-card-inc-dec-button"
                            onClick={() => DecrementHandler(cardIndex)}
                          >
                            -
                          </button>
                          <p className="purchase-product-card-selected-couonter">
                            {cardValue.counter}
                          </p>
                          <button
                            className="purchase-product-card-inc-dec-button"
                            onClick={() => {
                              cardData[cardIndex].counter =
                                cardData[cardIndex].counter + 1;
                              setCardData([...cardData]);
                            }}
                          >
                            +
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </Grid>
              );
            })}
          </Grid>
        </Box>
      </div>
    </SideMenu>
  );
};
export default PurchasesProduct;
